export const extranet = 'idufep.com'
export const intranet = 'dongc.com'

export const isInternallink = (host) => {
  return host.includes(extranet) || host.includes(intranet)
}

// const urlMap = {
//   '/web/web!courseDetail.do': '',
//   '/web/web!bookDetail.do': ''
// }

// export const replaceUrl = (host) => {

// }
